import React from 'react';
import { twMerge } from 'tailwind-merge';
import { BaseButton } from '@repo/common';

/**
 * Shared mobile Pathfinder question shell.
 * The body is intentionally composed through children so every question can use
 * the same navigation and spacing while supplying a different answer control.
 *
 * 높이는 100dvh 가 아니라 100dvh - GNB 로 잡는다. LogoOnlyGNB 가 모바일에서
 * 44px 짜리 스페이서를 먼저 깔기 때문에, 100dvh 를 그대로 쓰면 전체 문서가
 * 44px 만큼 길어지고 그 아래에 깔린 푸터(Back/Next)가 화면 밖으로 잘린다.
 * 안쪽 main 이 스크롤을 맡으므로 문서 자체는 스크롤되지 않아 되살릴 방법도 없다.
 */
const SHELL_HEIGHT = 'h-[calc(100dvh-44px)]';
function PathfinderMobileQuestionLayout({
  progressLabel,
  title,
  helperText,
  children,
  backLabel = 'Back',
  nextLabel = 'Next',
  nextDisabled = false,
  onBack,
  onNext,
  className = '',
  contentClassName = '',
}) {
  return (
    <section
      className={twMerge(
        `flex ${SHELL_HEIGHT} w-full flex-col overflow-hidden bg-grayscale-gray00`,
        className,
      )}
    >
      <main className='flex-1 min-h-0 px-4 py-8 overflow-y-auto bg-grayscale-gray00'>
        <div
          className={twMerge(
            'mx-auto flex w-full max-w-[868px] flex-col gap-8',
            contentClassName,
          )}
        >
          <div className='flex flex-col items-start w-full gap-2'>
            {progressLabel ? (
              <span className='rounded-[30px] bg-green-light01 px-2 py-1 typo-b11Strong text-green-deep02'>
                {progressLabel}
              </span>
            ) : null}
            {title ? (
              <h1 className='text-title1 text-text-primary'>{title}</h1>
            ) : null}
            {helperText ? (
              <p className='typo-b14 text-text-placeholder'>{helperText}</p>
            ) : null}
          </div>
          {children}
        </div>
      </main>

      {/* 홈 인디케이터가 있는 기기에서 버튼을 덮지 않도록 safe-area 만큼 더 띄운다 */}
      <footer className='flex min-h-[88px] shrink-0 items-center gap-2 bg-grayscale-gray00 px-4 pt-3 pb-[calc(env(safe-area-inset-bottom,0px)+24px)]'>
        {/*
          색·타이포·disabled 는 BaseButton 의 type/size 가 이미 정의한다.
          radius 만 className 으로 덮는데, BaseButton 이 rounded-full 을 고정으로 붙여
          rounded prop 으로는 8px 를 낼 수 없기 때문이다.
        */}
        <BaseButton
          type='text'
          size='l'
          htmlType='button'
          hideIcon
          onClick={onBack}
          bgclass='bg-grayscale-gray01'
          textclass='text-grayscale-gray07'
          hoverclass='hover:bg-grayscale-gray02 hover:text-grayscale-gray07'
          borderclass='border-transparent'
          className='min-w-0 rounded-[8px]'
        >
          {backLabel}
        </BaseButton>
        <BaseButton
          type='primary'
          size='l'
          htmlType='button'
          hideIcon
          isDisabled={nextDisabled}
          disabledBgClass='bg-grayscale-gray02'
          disabledTextClass='text-text-disable'
          disabledBorderClass='border-transparent'
          onClick={onNext}
          className='min-w-0 flex-1 rounded-[8px]'
        >
          {nextLabel}
        </BaseButton>
      </footer>
    </section>
  );
}

export default PathfinderMobileQuestionLayout;
